import React, { useState } from "react";
import {
  Image,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ActivityIndicator,
} from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";
import * as ImagePicker from "expo-image-picker";
import { toast } from "react-toastify";
import { uploadToS3 } from "../../services/authAPI";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import CretePrivateEventTooltip from "./CretePrivateEventTooltip";

const DurationAndQualityComponent = ({
  isOpenDuration,
  setIsOpenDuration,
  setIsOpen,
  type,
  duration,
  setDuration,
  isOpenQuality,
  setIsOpenQuality,
  quality,
  setQuality,
  durationAndQualityTooltip,
  setDurationAndQualityTooltip,
}) => {
  const styles = useStyles();

  const options = [
    { name: "1 hour" },
    { name: "2 hour" },
    { name: "3 hour" },
    { name: "4 hour" },
    { name: "5 hour" },
    { name: "6 hour" },
    { name: "Custom" },
  ];

  const qualityOptions = [
    { name: "Standard (720p, 30fps)" },
    { name: "High (1080p, 60fps)" },
    { name: "Ultra (4K, 60fps)" },
  ];

  const toggleDropdown = () => {
    setIsOpenDuration(!isOpenDuration);
    setIsOpen(false);
    setIsOpenQuality(false);
  };

  const handleDurationClick = (durationValue) => {
    setDuration(durationValue);
    setIsOpenDuration(false);
  };

  const toggleQualityDropdown = () => {
    setIsOpenQuality(!isOpenQuality);
    setIsOpen(false);
    setIsOpenDuration(false);
  };

  const handleQualityClick = (quality) => {
    setQuality(quality);
    setIsOpenDuration(false);
  };
  const deviceSize = useDeviceSize();

  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          gap: 12,
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
          Stream Duration & Quality
        </Text>
        <TouchableOpacity
          onPress={() =>
            setDurationAndQualityTooltip(!durationAndQualityTooltip)
          }
        >
          <Image
            source={AppImages.icInfoCircle}
            style={{
              height:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 17
                  : 20,
              width:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 17
                  : 20,
              resizeMode: "contain",
            }}
          />
        </TouchableOpacity>
        {durationAndQualityTooltip && (
          <CretePrivateEventTooltip
            heading="Stream Quality & Stream Duration"
            content={
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  Select your desired stream quality. Higher quality improves
                  audience experience but increases streaming costs (not by much
                  so its worth it 👌 .
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  Standard (720p, 30fps) → Lower cost, smooth performance.
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  ✅ High (1080p, 60fps) → Balanced quality and cost .
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  Ultra (4K, 60fps) → Best experience, highest cost.
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    {
                      color: AppColors.gray_C4C4C4,
                      lineHeight: 24,
                      marginTop: 12,
                    },
                  ]}
                >
                  "Select the estimated duration of your event. Streaming costs
                  are calculated based on the selected duration.
                </Text>
              </View>
            }
            width={355}
            right={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 0
                : 470
            }
            bottom={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 34
                : -80
            }
            visible={durationAndQualityTooltip}
            setVisible={setDurationAndQualityTooltip}
          />
        )}
      </View>
      <View
        style={[
          styles.mainInputWrapper,
          {
            position: "relative",
            zIndex: isOpenDuration || durationAndQualityTooltip ? -1 : 100,
            elevation: 0,
          },
        ]}
      >
        {/* Duration Dropdown */}
        <View style={styles.leftWrapper}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>Duration</Text>
          <View style={{ position: "relative", zIndex: 999 }}>
            <TouchableOpacity onPress={toggleDropdown}>
              <View style={styles.dropdownButtonStyle}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    styles.dropdownButtonTxtStyle,
                    {
                      color: AppColors.white,
                    },
                  ]}
                >
                  {duration || "Select Time"}
                </Text>
                <Icon
                  name={isOpenDuration ? "chevron-up" : "chevron-down"}
                  style={styles.dropdownButtonArrowStyle}
                />
              </View>
            </TouchableOpacity>

            {isOpenDuration && (
              <View
                style={{
                  position: "absolute",
                  left: 0,
                  width: "100%",
                  top: 50,
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  borderRadius: 10,
                  marginTop: 2,
                  backgroundColor: AppColors.black_121212,
                  zIndex: 1000,
                  elevation: 10,
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.2,
                  shadowRadius: 4,
                }}
              >
                {options.map((option, idx) => (
                  <TouchableOpacity
                    key={idx}
                    style={{
                      paddingVertical: 10,
                      paddingHorizontal: 12,

                      cursor: "pointer",
                    }}
                    onPress={() => handleDurationClick(option.name)}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          textAlign: "left",
                        },
                      ]}
                    >
                      {option.name}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>
            )}
          </View>
        </View>

        {/* Quality Dropdown */}
        <View style={[styles.leftWrapper, { zIndex: -1 }]}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>Quality</Text>
          <View style={{ position: "relative", zIndex: 999 }}>
            <TouchableOpacity onPress={toggleQualityDropdown}>
              <View style={styles.dropdownButtonStyle}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    styles.dropdownButtonTxtStyle,
                    {
                      color: AppColors.white,
                    },
                  ]}
                >
                  {quality || "Select Time"}
                </Text>
                <Icon
                  name={isOpenQuality ? "chevron-up" : "chevron-down"}
                  style={styles.dropdownButtonArrowStyle}
                />
              </View>
            </TouchableOpacity>

            {isOpenQuality && (
              <View
                style={{
                  position: "absolute",
                  left: 0,
                  width: "100%",
                  top: 50,
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  borderRadius: 10,
                  marginTop: 2,
                  backgroundColor: AppColors.black_121212,
                  zIndex: 1000,
                  elevation: 10,
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.2,
                  shadowRadius: 4,
                }}
              >
                {qualityOptions.map((option, idx) => (
                  <TouchableOpacity
                    key={idx}
                    style={{
                      paddingVertical: 10,
                      paddingHorizontal: 12,

                      cursor: "pointer",
                    }}
                    onPress={() => handleQualityClick(option.name)}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          textAlign: "left",
                        },
                      ]}
                    >
                      {option.name}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default DurationAndQualityComponent;

const useStyles = CreateResponsiveStyle(
  {
    mainInputWrapper: {
      flexDirection: "row",
      gap: 25,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 12,
    },
    dropdownButtonStyle: {
      width: "100%",
      height: 50,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 12,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      paddingHorizontal: 12,
    },
    dropdownButtonTxtStyle: {
      flex: 1,
      color: AppColors.white,
    },
    dropdownButtonArrowStyle: {
      fontSize: 28,
      color: AppColors.white,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainInputWrapper: {
        flexDirection: "row",
        gap: 25,
      },
      leftWrapper: {
        flex: 0.5,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
    },
  }
);
